import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, X } from 'lucide-react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show after a delay so it's not immediate
      const dismissed = localStorage.getItem('vent_pwa_dismissed');
      if (!dismissed) {
        setTimeout(() => setShowPrompt(true), 10000);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('vent_pwa_dismissed', 'true');
  };

  return (
    <AnimatePresence>
      {showPrompt && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:w-80 glass rounded-2xl p-4 z-40 border border-vent-primary/20"
          data-testid="pwa-install-prompt"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-vent-primary/20 flex items-center justify-center shrink-0">
              <Download className="w-5 h-5 text-vent-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-semibold mb-1">Install Vent</p>
              <p className="text-zinc-500 text-xs">Add to home screen for the full experience</p>
            </div>
            <button onClick={handleDismiss} className="p-1 hover:bg-white/10 rounded-lg shrink-0">
              <X className="w-4 h-4 text-zinc-500" />
            </button>
          </div>
          <button
            onClick={handleInstall}
            className="w-full mt-3 py-2.5 bg-vent-primary text-white text-sm font-heading font-bold tracking-wider rounded-xl hover:bg-vent-primary/80 transition-colors"
            data-testid="pwa-install-btn"
          >
            INSTALL
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PWAInstallPrompt;
